import {takeLatest} from 'redux-saga';
import {call, put} from 'redux-saga/effects';
import {push} from 'react-router-redux';

import {changeApprovedStatus} from 'api/index';
import {fetchUsers, updateUser} from 'actions/api';

import {TOGGLE_USER_APPROVED, USERS_NS} from 'constants/index';

import {matchAction} from 'utils/helpers';

import {actionCreators} from 'utils/resourcerizer';

const {initialize, insert, updateOne} = actionCreators(USERS_NS);
console.log(TOGGLE_USER_APPROVED)
export default function() {
  return [
    takeLatest(TOGGLE_USER_APPROVED, function*(action) {
      const {payload: {id, isApproved}} = action;

      //using ad-hoc api endpoint because of the email hooks
      try {
        const user = yield call(changeApprovedStatus, id);
        yield put(updateOne(id, user));
      } catch (err) {
        console.warn(err);
      }

      //below uses REST api call
      // const fetch = yield put(updateUser(id,{isApproved}));
      // const res = yield fetch;
      // if (res.type === 'SUCCESS') {
      //   yield put(addUser(res.payload));
      // } else if (res.type === 'FAILURE') {
      //   console.error('Failed to update', res.payload);
      // }
    }),

    takeLatest(matchAction(initialize()), function*() {
      const fetch = yield put(fetchUsers());
      const res = yield fetch;
      if (res.type === 'SUCCESS') {
        yield put(insert(res.payload));
      } else if (res.type === 'FAILURE') {
        console.error('Failed to fetch', res.payload);
      }
    })
  ];
}



// WEBPACK FOOTER //
// ./src/sagas/users.js